import React, { ReactElement, useEffect, useMemo } from 'react'
// import SortBySelect from './SortBySelect'
import { BsFilter } from 'react-icons/bs'

import { CloseIcon, SearchIcon } from '@chakra-ui/icons'
import {
  Box,
  Button,
  Center,
  Collapse,
  Divider,
  Flex,
  HStack,
  IconButton,
  Input,
  InputGroup,
  Spacer,
  Text,
  VStack,
  useBoolean,
  useMediaQuery,
} from '@chakra-ui/react'

import { SearchType, SortByOption } from '../../pages/discover'
import SearchTypeSelect from './SearchTypeSelect'
import TagSelector from './TagSelector'

interface Props {
  searchInput: string
  onSearchInputChange: (input: string) => void
  onKeyDown: React.KeyboardEventHandler
  searchType: SearchType
  onSelectSearchType: (type: SearchType) => void
  onTagsChange: (tags: string[]) => void
  sortBy: SortByOption
  onChangeSortBy: (option: SortByOption) => void
  onSearch: () => void
  filterTags: string[]
}

const SearchBar = ({
  searchInput,
  onSearchInputChange,
  onTagsChange,
  onKeyDown,
  searchType,
  onSelectSearchType,
  filterTags,
}: // sortBy,
//onChangeSortBy,
// onSearch,
Props): ReactElement => {
  const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value
    onSearchInputChange(input)
  }

  const [showFilters, { toggle: toggleShowFilters, off: hideFilters }] =
    useBoolean()

  const placeholder: string = useMemo(() => {
    switch (searchType) {
      case 'all':
        return 'Search dashboards and users'
      case 'dashboards':
        return 'Search by title or topic'
      case 'users':
        return 'Search by username'
    }
  }, [searchType])

  useEffect(() => {
    if (searchType == 'users') {
      hideFilters()
    }
  }, [searchType, hideFilters])

  const [isMobile] = useMediaQuery('(max-width: 840px)')
  const filtersButton = (
    <Button
      bg="white"
      onClick={toggleShowFilters}
      variant={'outline'}
      minW={'max-content'}
      isDisabled={searchType === 'users'}
    >
      <HStack>
        <BsFilter />
      </HStack>
    </Button>
  )

  const searchTypeSelector = (
    <SearchTypeSelect
      onSelect={onSelectSearchType}
      value={searchType}
      isMobile={isMobile}
    />
  )

  return (
    <VStack spacing={0} w="100%" align={'stretch'} pos="relative">
      <HStack w="100%" mt={4} spacing={6}>
        <InputGroup
          borderRadius="6px"
          h="60px"
          // pl={5}
          // py={4}
          boxShadow="0 0.75px 2.5px rgb(0 0 0 / 0.5)"
          bg="white"
        >
          <Flex h="100%" px={6} pr={4} w="100%" align={'center'}>
            <Center>
              <SearchIcon color="gray.500" fontSize="1em" mt="2px" />
            </Center>
            <Input
              p={2}
              variant="unstyled"
              value={searchInput}
              size="lg"
              onChange={handleSearchInputChange}
              onKeyDown={onKeyDown}
              placeholder={placeholder}
              fontSize={'1em'}
            />
            {searchInput !== '' && (
              <IconButton
                variant={'unstyled'}
                aria-label="clear"
                icon={<CloseIcon color="gray.500" fontSize={'0.8em'} />}
                onClick={() => onSearchInputChange('')}
                mx={isMobile ? 0 : 1}
              />
            )}

            {!isMobile && (
              <>
                <Spacer />
                <Divider orientation="vertical" borderWidth={'1px'} h="60%" />
                <Spacer />
                <Flex align={'flex-end'} w="9rem">
                  <Spacer />
                  {searchTypeSelector}
                </Flex>{' '}
              </>
            )}

            {/* <Divider orientation="vertical" borderWidth={'1px'} mx={4} /> */}
          </Flex>

          {/* <InputRightElement
            ml={4}
            width="4.5rem"
            backgroundColor={'gray.100'}
            borderTopRightRadius={'6px'}
            borderBottomRightRadius={'6px'}
            h="100%"
            onClick={onSearch}
            as="button"
            _hover={{ bg: 'gray.200' }}
            _active={{ bg: 'gray.300' }}
          >
            <SearchIcon color="gray.500" />
          </InputRightElement> */}
        </InputGroup>

        {!isMobile && filtersButton}
      </HStack>
      {isMobile && (
        <HStack pt={4} spacing={8} align={'flex-end'}>
          <Box w="12rem">{searchTypeSelector}</Box>
          <Spacer />
          {filtersButton}{' '}
        </HStack>
      )}
      <Collapse in={showFilters}>
        <HStack w="100%" align={'flex-start'} mt={4} spacing={6} minH="5rem">
          <VStack align={'flex-start'} pos={'absolute'} w="100%">
            <Text fontWeight="semibold">Topic tags</Text>
            <TagSelector tags={filterTags} onChange={onTagsChange} />
          </VStack>
          {/* <VStack align={'flex-start'}>
            <Text fontWeight="semibold">Sort by</Text>
            <SortBySelect value={sortBy} onSelect={onChangeSortBy} />
          </VStack> */}
        </HStack>
      </Collapse>
    </VStack>
  )
}

export default SearchBar
